import { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Footer from "../../components/Elements/Footer";
import { Header } from "../../components/Elements/Header";
import FutureAppointmentsList from "./components/FutureAppointmentsList";
import PastAppointmentsList from "./components/PastAppointmentsList";

const ConsultasPage = () => {
  const [key, setKey] = useState('future');
  const handleSelect = (eventKey: string | null) => {
    if (eventKey) {
      setKey(eventKey);
    }
  };
  return (
    <>
      <Header />
      <div id="wrapper" className="p-0">
        <div className="page-header flex-fill justify-content-start">
          <div className="shape"></div>
          <div className="container position-relative py-5">
            <h1 className="text-center mb-5">Minhas Consultas</h1>
            <Tab.Container defaultActiveKey={key}>
              <div className="row align-items-end position-relative z-1">
                <div className="col col-auto">
                  <Nav variant="tabs" className="align-items-end border-0 px-3" onSelect={handleSelect}>
                    <Nav.Item>
                      <Nav.Link className={`${key != 'future' && 'text-white'} fs-5`} eventKey="future">
                        <i className={`las la-calendar-alt me-2 ${key == 'future' ? 'text-primary' : 'opacity-50'}`}></i>Próximas Consultas
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link className={`${key != 'past' && 'text-white'} fs-5`} eventKey="past">
                        <i className={`las la-calendar-check me-2 ${key == 'past' ? 'text-primary' : 'opacity-50'}`}></i>Consultas já realizadas
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
              <div className="card text-body p-3">
                <div className="listagem">
                  <Tab.Content className="flex-grow-1 d-flex flex-column overflow-hidden">
                    <Tab.Pane eventKey="future">
                      <FutureAppointmentsList />
                    </Tab.Pane>
                    <Tab.Pane eventKey="past">
                      <PastAppointmentsList />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </div>
            </Tab.Container>
          </div>
        </div>
      </div >
      <Footer />
    </>
  );
};

export default ConsultasPage;
